/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export const WebAppCreateEditDtoSourceTypeEnum = {
    FRAGMENT: "FRAGMENT"
} as const;

export type WebAppCreateEditDtoSourceTypeEnumKey = (typeof WebAppCreateEditDtoSourceTypeEnum)[keyof typeof WebAppCreateEditDtoSourceTypeEnum];

export const WebAppCreateEditDtoSourceTypeEnum2 = {
    COMPOSITION: "COMPOSITION"
} as const;

export type WebAppCreateEditDtoSourceTypeEnum2Key = (typeof WebAppCreateEditDtoSourceTypeEnum2)[keyof typeof WebAppCreateEditDtoSourceTypeEnum2];

export type WebAppCreateEditDto = (({
    /**
     * @type string
    */
    sourceType: WebAppCreateEditDtoSourceTypeEnumKey;
    /**
     * @type string, uuid
    */
    sourceId: string;
    /**
     * @minLength 1
     * @type string
    */
    name: string;
    /**
     * @type object | undefined
    */
    config?: {
        /**
         * @type string | undefined, uri
        */
        videoUrl?: string;
        /**
         * @type string | undefined, uri
        */
        captionsUrl?: string;
    };
} & {
    sourceType: "FRAGMENT";
}) | ({
    /**
     * @type string
    */
    sourceType: WebAppCreateEditDtoSourceTypeEnum2Key;
    /**
     * @type string, uuid
    */
    sourceId: string;
    /**
     * @minLength 1
     * @type string
    */
    name: string;
    /**
     * @type object | undefined
    */
    config?: {
        /**
         * @type string | undefined, uri
        */
        videoUrl?: string;
        /**
         * @type string | undefined, uri
        */
        captionsUrl?: string;
    };
} & {
    sourceType: "COMPOSITION";
}));